import React from 'react';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';

const ReturnPreviewInfo = ({ string, languages }) => {
  if (!string) return null;
  return (
    <StaticApplicationMessage
      messageType="applicationInfo"
      string={string}
      languages={languages}
      nodismiss
    />
  );
};


export default ReturnPreviewInfo;
